import { SET_DPPA, REMOVE_DPPA, SET_STATE, REMOVE_STATE } from "../types";

export default function dppaAndState(state = {}, action = {}) {
  switch (action.type) {
    case SET_DPPA: {
      let newDppaAndState = state.dppaAndState;
      if (!newDppaAndState) newDppaAndState = {};
      newDppaAndState.dppa = action.dppa;
      return {
        ...state,
        dppaAndState: newDppaAndState,
      };
    }
    case REMOVE_DPPA: {
      const newDppaAndState = state.dppaAndState;
      if (newDppaAndState) delete newDppaAndState.dppa;
      return { ...state, dppaAndState: newDppaAndState };
    }
    case SET_STATE: {
      let newDppaAndState = state.dppaAndState;
      if (!newDppaAndState) newDppaAndState = {};
      newDppaAndState.state = action.state;
      return {
        ...state,
        dppaAndState: newDppaAndState,
      };
    }
    case REMOVE_STATE: {
      const newDppaAndState = state.dppaAndState;
      delete newDppaAndState.state;
      return { ...state, dppaAndState: newDppaAndState };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dppaAndState.js